import { useEffect, useState } from "react";
import { endpoints } from "../../../utils/Constants";

export type CountryOption = { Code: string; Name: string };

let cache: CountryOption[] | null = null;
let inflight: Promise<CountryOption[]> | null = null;

const MAX_RETRIES = 3;

async function attemptFetch(): Promise<CountryOption[]> {
  for (let i = 0; i < MAX_RETRIES; i++) {
    try {
      const r = await fetch(endpoints.common.getCountries);
      if (!r.ok) throw new Error(`countries fetch failed: ${r.status}`);
      return r.json() as Promise<CountryOption[]>;
    } catch (err) {
      if (i === MAX_RETRIES - 1) throw err;
      await new Promise((resolve) => setTimeout(resolve, 1000 * 2 ** i));
    }
  }
  throw new Error("unreachable");
}

function fetchCountries(): Promise<CountryOption[]> {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = attemptFetch()
    .then((data) => {
      cache = data;
      inflight = null;
      return data;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });
  return inflight;
}

export function useCountriesOptions(enabled = true): CountryOption[] {
  const [options, setOptions] = useState<CountryOption[]>(cache ?? []);

  useEffect(() => {
    if (!enabled) return;
    if (cache) {
      setOptions(cache);
      return;
    }
    fetchCountries()
      .then(setOptions)
      .catch((err) => console.error(err));
  }, [enabled]);

  return options;
}
